<template>
  <div style="height:100vh;overflow:hidden;" class="background animate__animated animate__fadeIn">
    <div style="clear:both;height:20%"></div>

    <div class="w-full max-w-xs mx-auto">
      <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Username</label>
          <input
            class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="username"
            type="text"
            placeholder="Username"
            v-model="username"
          />
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">Password</label>
          <input
            class="appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
            id="password"
            type="password"
            placeholder="******************"
            v-model="password"
          />
          <p class="text-red-500 text-xs italic">Please choose a password.</p>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">Repeat password</label>
          <input
            class="appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
            id="password"
            type="password"
            placeholder="******************"
            v-model="password_repeat"
          />
          <p class="text-red-500 text-xs italic">Please choose a password.</p>
        </div>
        <div class="flex items-center justify-center">
          <button
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
          >Sign In</button>
        </div>
      </form>
      <div class="section">
        Crea una cuenta de usuario para recuperar tus puntuaciones si accedes desde otro dispositivo.
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "app-auth",
  mounted: function () {},
  created: function () {},
  methods: {
    onPlayClicked() {
      this.$router.push("playing");
    },
    onInstructionsClicked() {
      this.$router.push("instructions");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/00-Auth.vue